module.exports = __webpack_public_path__ + "static/img/cover.42ebaa3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_2/cover.jpg
// module id = xxgI
// module chunks = 0